import { ReactNode, useEffect } from 'react';
import useModal from '@javascript/lib/hooks/useModal';
import InstantSearchFilterFooter from './units/instantSearchFiltersFooter';
import InstantSearchFilterButton from './units/instantSearchFilterButton';
import { useCustomClearRefinements } from '@javascript/lib/hooks/useCustomClearRefinements';

interface InstantSearchFiltersModalProps {
  children: ReactNode;
  onModalToggle: (isOpen: boolean) => void;
}

const InstantSearchFiltersModal = ({
  children,
  onModalToggle,
}: InstantSearchFiltersModalProps) => {
  const { ref, openModal, closeModal, maskClickHandlers } = useModal({
    handlers: {
      onClose: () => onModalToggle(false),
      onOpen: () => onModalToggle(true),
    },
    stopInsideFocus: true,
  });
  const { refine } = useCustomClearRefinements();

  useEffect(() => {
    // Check if the query parameter "dialog=open" is present
    const params = new URLSearchParams(window.location.search);
    if (params.get('dialog') === 'open') {
      openModal();
    }
  }, [window.location.search]);

  return (
    <>
      <InstantSearchFilterButton onClick={openModal} />
      <dialog {...maskClickHandlers} ref={ref}>
        <div className="instant-search-modal ch-modal ch-modal--drawer">
          <header>
            <div className="ch-pl--2 ch-pr--1 sl:ch-ph--6 ch-pv--4 ch-display--flex ch-flex-flow--row-wrap ch-justify-content--between ch-align-items--center ch-width--12 ch-bb--1 ch-bc--grey-3">
              <h1 className="instant-search-modal__title ch-mb--0 ch-fs--4 ch-fw--500">
                Filter and sort
              </h1>
              <button
                className="ac-instant-search__clear-filters ch-ml--auto ch-btn ch-btn--link ch-color--ac-red ch-flex--none"
                onClick={refine}
                type="button"
              >
                Clear all
              </button>
              <button
                className="ac-modal__close ac-modal__close--filters ch-mr--1"
                onClick={closeModal}
                type="button"
              >
                <span className="ch-reader">Close</span>
              </button>
            </div>
          </header>
          {children}
          <InstantSearchFilterFooter closeModal={closeModal} />
        </div>
      </dialog>
    </>
  );
};

export default InstantSearchFiltersModal;
